var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23627",
    "data-name": "Path 23627",
    d: "M85.415,41.684H63.931c-1.411-.482-1.758-.94-1.758-2.322V29.436q0-7.832.01-15.664a2.63,2.63,0,0,1,.232-1.046,2.083,2.083,0,0,1,1.515-1.043H76.756q0,3.6,0,7.2c0,1.431.816,2.17,2.4,2.17h8.008c.006.078.012.125.012.172q0,9.27-.01,18.539a2.154,2.154,0,0,1-.245.9A2.112,2.112,0,0,1,85.415,41.684ZM78.862,24.822V37.91h4.127V24.822ZM76.75,28.577H72.612V37.91H76.75ZM66.362,32.322v5.588h4.127V32.322Z",
    transform: "translate(-62.172 -11.684)",
    fill: "#277ef5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23628",
    "data-name": "Path 23628",
    d: "M250.562,11.682a2.388,2.388,0,0,0,.21.245q3.875,3.492,7.753,6.981c.082.074.16.152.271.256h-8.3V11.682Z",
    transform: "translate(-233.83 -11.682)",
    fill: "#277ef5",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.18945a0ef14f02ab41d15d0f955a64a8.svg";
export { ForwardRef as ReactComponent };